import { Trans } from '@lingui/macro';
import NgpTextField from '../../../../form/NgpTextField';
import { DescriptionField } from '../../../infrastructure/InfrastructureFieldComponents';
import { TEST_DESCRIPTION_FIELD, TEST_NAME_FIELD, TEST_TAGS_FIELD } from '../../ServiceTestsConstants';
import { NgpTagsField } from '../../../../form/NgpTagsField';
import { useTags } from '../../../../../services/FormQueryService';
import useNgpFormContext from '../../../../../utilities/NgpFormContextProviderUtilities';
import TestFormSection from './TestFormSection/TestFormSection';

const testsTagsUrl = '/ipm/v1/open/tests/tags';

const NAME_SIZE = 60;
const NAME_MAX_LENGTH = 128;
const DESCRIPTION_SIZE = 80;

const TestBaseInformationSection = () => {
    const { formData } = useNgpFormContext();
    const { tags: testTags } = useTags({ url: testsTagsUrl });

    return (
        <TestFormSection title={<Trans>Basic Information</Trans>}>
            <NgpTextField
                fieldName={TEST_NAME_FIELD}
                label={<Trans>Name</Trans>}
                required
                inputProps={{ size: NAME_SIZE, maxLength: NAME_MAX_LENGTH, autoFocus: true }}
            />
            <DescriptionField fieldName={TEST_DESCRIPTION_FIELD} cols={DESCRIPTION_SIZE} />
            <NgpTagsField
                fieldName={TEST_TAGS_FIELD}
                defaultValue={formData[TEST_TAGS_FIELD]}
                label={<Trans>Tags</Trans>}
                options={testTags}
            />
        </TestFormSection>
    );
};

export default TestBaseInformationSection;
